import { Trans, useTranslation } from "react-i18next";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Shell } from "@/components/Shell";

/**
 * A page and no session: on an open door, a signed-in application that happens to be empty
 * invites a stranger to wander it. The Veiligheidsregio hint comes first because it is the only
 * lever that shortens the beheerder's queue without moving risk (docs/adr/0018-identity-linking.md).
 */
export function AccountUnknown() {
  const { t } = useTranslation(["account", "common"]);
  const mailbox = t("common:mailbox");

  return (
    <Shell>
      <Card>
        <CardHeader>
          <CardTitle>{t("unknown.title")}</CardTitle>
          <CardDescription>{t("unknown.description")}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3 text-sm">
          <p>
            <Trans t={t} i18nKey="unknown.veiligheidsregio" components={{ strong: <strong /> }} />
          </p>
          <p>
            {t("unknown.mailBefore")}
            <a className="jb-link" href={`mailto:${mailbox}`}>
              {mailbox}
            </a>
            {t("unknown.mailAfter")}
          </p>
          <p className="text-muted-foreground">{t("unknown.portaal")}</p>
          <p>
            <a className="jb-link" href="/">
              {t("common:actions.backToStart")}
            </a>
          </p>
        </CardContent>
      </Card>
    </Shell>
  );
}
